<!-- 水泵节能日报表 -->
<template>
    <div class='container'>
        <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
                <el-page-header style="height:40px;line-height:40px;" @back="goBack" content="空调系统节能日报"></el-page-header>
            </div>
            <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="选择月份">
                    <el-date-picker
                        v-model="form.time"
                        type="month"
                        placeholder="选择月份"
                        value-format="yyyy-MM-dd"
                        @change="choseTime">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
            <div class="energy-box">
                <ul class="situation-list">
                    <li class="situation-flex">
                        <span>今日用量：{{sum_electricity}} kWh</span>
                        <span>日运行时长：{{running_time}} 
                            <!-- <el-tooltip :content="content" placement="top" effect="light">
                                <i class="el-icon-info"></i>
                            </el-tooltip> -->
                        </span>
                    </li>
                </ul>
            </div>
            <div class="charts-box" >
                <div id="charts"  style="width: 100%;height:100%;"></div>
                <div class="nodata" v-show="energy_pump.length===0">
                    --  暂无数据 --
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import echarts from "echarts"
import Service from '@/api/Service'
import { FormatDate, FormatDateDay, getCurrentMonthLast } from '@/utils/utils.js'

var chart1 = null
const mGetDate = function(){
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth()+1;
    let d = new Date(year, month, 0);
    return d.getDate();
}

export default {
    data() {
        return {
            form: {
                day: '',
                time: FormatDate('yyyy-MM-dd')
            },
            energy_pump: [],    
            sum_electricity: 0,
            running_time_list: [],
            content: '',
        };
    },

    components: {},

    computed: {
        // 运行时间
        running_time() {
            let arr = []
            this.running_time_list.map(v=>{
                let list = v.running_time_list
                // let running_time = v.running_time_list.map(v=>{return v.value})
                let value = list[list.length - 1].value
                arr.push(`${v.terminal_serial}： ${value}h`)
            })
            return arr.join(' / ')
        }
    },

    mounted() {
        this.$nextTick(()=>{

            // 基于准备好的dom，初始化echarts实例
            chart1 = echarts.init(document.getElementById('charts'));

            let time = FormatDate('yyyy-MM-dd')
            this.getTableData(time)
        })
        
    },

    methods: {
        
        async getTableData(time) {
            time = time + ' 11:59:59'
            let time_range = 'day'
            let res = await Service.getPLCStatisticByPIDTimeRange({time_range, time})
            if(res) {
                let list = res.electricity.sum_electricity.map(v=>{return v.value})
                this.sum_electricity = list[list.length-1]

                this.running_time_list = res.running_time_list

                this.energy_pump = res.electricity_fee.sum_electricity_fee.map(v=>{return v.value})
                this.initData()
            }
        },
        choseTime(val) {
            if(!val) return
            this.form.time = getCurrentMonthLast(val)
        },
        // 查询
        onSubmit() {
            let time = this.form.time
            this.getTableData(time);
        },
        initData() {
            this.initChart1(this.energy_pump)
        },
        initChart1(nowDay) {
            let option = this.getOption();
            option.series =  [
                {
                    name: '总电费',
                    type: 'bar',
                    smooth: true,
                    itemStyle: {
                        color: 'rgba(56, 191, 96, 1)'
                    },
                    data: nowDay,
                },
            ]
            chart1.setOption(option);
        },
        getOption() {
            let Len = mGetDate();
            let Axis = []
            for (let index = 0; index < Len; index++) {
                Axis.push(index+1 + '日')
                
            }
            
            return {
                tooltip: {
                    trigger: 'axis',
                    padding: [
                        5,  // 上
                        10, // 右
                        5,  // 下
                        10, // 左
                    ],
                    axisPointer: {
                        type: 'cross',
                    }
                },
                legend: {
                    data: ['总电费'],
                    right: 160,
                    top: 10,
                },
                grid: {
                    left: 70,
                    right: 20,
                    bottom: 30,
                    top: 30,
                },
                
                xAxis: [
                    {
                        type: 'category',
                        data: Axis
                    },
                ],

                yAxis: [
                    {
                        type: 'value',
                        name: '元',
                    }
                ],
                series: [
                    {
                        name: '总电费',
                        type: 'bar',
                        smooth: true,
                        itemStyle: {
                            color: 'rgba(56, 191, 96, 1)'
                        },
                        data: [],
                    },
                ],
            }
        },
        goBack() {
            this.$router.go(-1);//返回上一层
        }
    }
}

</script>
<style lang='less' scoped>
.charts-box{
    width: 60%;
    height: 400px;
    margin: 100px auto 0;
    #charts{
        width: 100%;
        height: 100%;
    }
}
.situation-list{
    margin: 10px;
    .situation-flex{
        display: flex;
        flex-direction: row;
        span{
            flex: 1;
            text-align: left;
            font-size: 14px;
            color: #666;
            line-height: 40px;
            margin: 5px 0;
            text-align: left;
            padding: 0 20px;
        }
    }
}
</style>